(function () {

  'use strict';

  eclipseApp.factory('internetPackageService', ['$http', function ($http) {
    return {
      getInternetPackage: function (endpoint, params) {
        return $http({
          url: endpoint,
          method: 'POST',
          data: params,
          cache: false
        });
      }
    };
  }]);

})();
